import { RequestService } from '../../../../common/services/RequestService';
import { API_PROFILE } from '../../../Authorization/api/constants';
import { adjustEditProfileData } from './adjustEditProfileData';

export const updateProfileRequest = async (userId, profileId, data) => {
  const response = await RequestService.put(
    API_PROFILE + '/' + profileId + '/update_and_fill',
    JSON.stringify({
      user: {
        user_id: userId,
        lastname: data.lastname,
        name: data.name,
        patronymic: data.patronymic,
        birth_date: data.birthDate.format('YYYY-MM-DD'),
        email: data.email,
      },
    })
  );
  return adjustEditProfileData(response.data);
};
